import { Button, Col, Row, Space, Typography } from "antd";
import React from "react";
import { NavLink } from "react-router-dom";
import LayoutHome from "./LayoutHome";
import { HomeOutlined } from "@ant-design/icons";
import backgroundImage from "../../assets/technogy.png";

const { Title, Paragraph } = Typography;

const ErrorPage = () => {
  return (
    <LayoutHome>
      <Row
        gutter={[32, 32]}
        justify="center"
        align="middle"
        style={{
          minHeight: "70vh",
          padding: "24px",
        }}
      >
        <Col xs={24} md={12} lg={10}>
          <Space
            direction="vertical"
            size={16}
            style={{
              width: "100%",
              maxWidth: 420,
              textAlign: "center",
              margin: "0 auto",
            }}
          >
            <Title level={2} style={{ marginBottom: 0 }}>
              Oops! Page not found
            </Title>
            <Paragraph type="secondary" style={{ marginBottom: 0 }}>
              The page you are looking for might have been removed, had its name
              changed, or is temporarily unavailable.
            </Paragraph>
            <NavLink to="/" style={{ display: "block" }}>
              <Button
                type="primary"
                size="large"
                icon={<HomeOutlined />}
                block
              >
                Back To Home
              </Button>
            </NavLink>
          </Space>
        </Col>
        <Col xs={20} sm={16} md={10} lg={8}>
          <div
            style={{
              width: "100%",
              maxWidth: 360,
              margin: "0 auto",
            }}
          >
            <img
              src={backgroundImage}
              alt="Illustration representing a missing page"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "contain",
              }}
            />
          </div>
        </Col>
      </Row>
    </LayoutHome>
  );
};

export default ErrorPage;
